import { baseServiceInvoiceSchema } from "@redotech/redo-model/billing/service-invoice";
import * as z from "zod/v4";

export const getFinalizedReturnsInvoices = {
  name: "getFinalizedReturnsInvoices" as const,
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
